export default {
  modul: 'Go to tasks module',
  gps: 'GPS',
  version: 'Version',
  notification: ' No Notifications',
  administration: 'Administration',
  support: 'Support',
  contactSupport: 'Contact Support',
  news: 'News',
  profile: 'Profile',
  logout: 'Log Out',
  adm: 'Administration',
  user: {
    profile: 'User',
    api_keys: 'API keys'
  },
  home: 'Home',
  dashboard: 'Dashboard',
  calendar: 'Calendar',
  'analytics-dashboards': {
    index: 'Analytics'
  },
  routines: {
    index: 'Routines'
  },
  'notices': {
    index: 'News'
  },
  'admin-notices-center': {
    index: 'News'
  },
  'admin-forms': {
    index: 'Forms',
    edit: 'Edit Forms',
    build: 'Create Forms',
    preview: 'Preview',
    new: 'New Form'
  },
  action_plans: {
    index: 'Tasks',
    new: 'New Action Plan',
    fill: 'Fill Action Plan',
    edit: 'Edit Action Plan',
    show: 'Tasks'
  },
  missions: {
    index: 'Missions'
  },
  occurrences: 'Forms',
  occurrence_fill: 'Fill Form',
  quick_check: {
    index: 'Quick Check'
  },
  service_desk: {
    index: 'Service Desk'
  },
  control_tower: {
    index: 'Control Tower'
  },
  dashboard2: {
    index: 'Analytics'
  },
  reports: {
    index: 'Reports',
    report: 'Report'
  },
  photosGallery: {
    index: 'Gallery',
    dashboard: 'Photos Gallery',
    SprintGallery: 'Sprint Gallery',
    FormGallery: 'Form Gallery'
  },
  caducities: {
    index: 'Caducities'
  },
  exhibitions: {
    // The app header keeps "Exhibitions" across the whole module; the in-page
    // header (next to the back arrow) shows the per-view context.
    index: 'Exhibitions',
    new: 'Exhibitions',
    show: 'Exhibitions',
    details: 'Exhibitions',
    settings: 'Exhibitions'
  },
  'admin-organizations': {
    index: 'Organizations',
    'index-table': 'Organizations',
    new: 'Create Organization',
    edit: 'Edit Organization'
  },
  'admin-organization-subaccounts': {
    index: 'Subaccounts',
    new: 'Create Subaccount',
    edit: 'Edit Subaccount'
  },
  'admin-franchises': {
    index: 'Franchises',
    edit: 'Edit Franchise',
    new: 'Create Franchise'
  },
  'admin-locations': {
    index: 'Locations',
    edit: 'Edit Location',
    new: 'Create Location',
    groups: 'Manage Groups'
  },
  'admin-roles': {
    index: 'Roles',
    edit: 'Edit Role',
    new: 'Create Role',
    tree: 'Roles Org Chart',
    tree_configuration: 'Org Chart Configuration'
  },
  'admin-users': {
    index: 'Users',
    edit: 'Edit User',
    new: 'Create User'
  },
  'manager-users': {
    index: 'Users',
    edit: 'Edit User'
  },
  'admin-catalogs': {
    index: 'Catalogs',
    edit: 'Edit Catalog',
    new: 'Create Catalog'
  },
  'admin-notifications-center': {
    index: 'Notifications Center'
  },
  'admin-calendar': {
    index: 'Agenda',
    new: 'Create Sprint',
    edit: 'Sprint Edit'
  },
  'admin-campaigns': {
    index: 'Campaigns',
    new: 'Create Campaign',
    edit: 'Edit Campaign'
  },
  'admin-sprints': {
    index: 'Sprints'
  },
  mailing: {
    index: 'Mailing'
  },
  'super-admin-organizations': {
    index: 'Organizations',
    'index-table': 'Organizations',
    new: 'Create Organization',
    edit: 'Edit Organization'
  },
  'super-admin-users': {
    index: 'Users',
    edit: 'Edit User',
    new: 'Create User',
    'index-table': 'Users'
  },
  'super-admin-licenses': {
    index: 'Licenses',
    franchises: 'Licenses by business unit',
    users: 'User licenses',
    report: 'License report'
  },
  'super-admin-analytics': {
    index: 'Analytics',
    'dashboard-new': 'New dashboard',
    'dashboard-edit': 'Edit dashboard',
    organization: 'Organization'
  },
  'super-admin-forms': {
    index: 'Forms',
    edit: 'Edit Forms',
    new: 'New Form',
    'build-cloned': 'Build Cloned Form',
    build: 'Create Forms',
    preview: 'Preview'
  },
  'super-admin-franchises': {
    index: 'Franchises',
    edit: 'Edit Franchise',
    new: 'Create Franchise'
  },
  'super-admin-locations': {
    index: 'Locations',
    edit: 'Edit Location',
    new: 'Create Location',
    groups: 'Manage Groups'
  },
  'super-admin-roles': {
    index: 'Roles',
    edit: 'Edit Role',
    new: 'Create Role'
  },
  'super-admin-catalogs': {
    index: 'Catalogs',
    edit: 'Edit Catalog',
    new: 'Create Catalog'
  },
  'super-admin-sprints': {
    index: 'Sprints'
  },
  'super-admin-campaigns': {
    index: 'Campaigns',
    new: 'Create Campaign',
    edit: 'Edit Campaign'
  },
  'super-admin-mailing': {
    index: 'Mailing'
  },
  'dashboard-settings': 'Settings',
  'admin-settings': 'Configuration',
  // Rutas de administración — módulo de encuestas / Voice Value (routes/admins.js)
  survey: {
    view: 'Survey preview',
    edit: 'Survey configuration',
    link: 'Survey link'
  },
  'admin-surveys': {
    brand: 'Voice Value',
    index: 'Surveys'
  },
  resources: {
    index: 'Resources',
    create: 'Create Resource',
    show: 'Resource'
  },
  aria: {
    index: 'Aria Documentation',
    new: 'Create Document or Report',
    edit: 'Edit document or report'
  },
  'user-profile': 'Profile'
}
